<script setup>

import {useRoute} from "vue-router";
import {useAuthStore} from "@/stores/auth.store";

const route = useRoute();
const token = route.params.token;
const authStore = useAuthStore();

const performLogin = async () => {
  await authStore.loginV1(token);
};

performLogin();

</script>

<template>
  <van-row justify="center">Loading...</van-row>
</template>
